import SocialMediaNavigator from "../../../navigation/SocialMediaNavigator";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import styles from "./socialMediaSettings.module.css";

const SocialMediaSettings = () => {
  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          <div className={styles.linkWrapper}>
            <PageLink destination="/dashboard/social-media/show-social-media">
              السوشال ميديا
            </PageLink>
          </div>
        </div>
      </HorizantalBar>
      <SocialMediaNavigator />
    </div>
  );
};

export default SocialMediaSettings;
